import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import commonProps from '../common/common.js'
import ModelsList from '../views/ModelsList.vue'
import SingleModel from '../views/ModelDetails.vue'
import UserProfile from '../views/UserProfile.vue'
//import Subscriptions from '../views/SubscriptionsList.vue'
import UsersManagement from '../views/UsersList.vue'
import LegacySubscription from '../views/LegacySubscription.vue'
//import Login from '../views/Login.vue'

const common = new commonProps()
const routes = [
  {
    path:'/',
    name:'models-list',
    component: ModelsList,
    meta: {
      requiresAuth:true
    }
  },
  {
    path:'/model-details/:model_id',
    component:SingleModel,
    meta: {
      requiresAuth:true
    },
    name:'models-details'
  },
  {
    path:'/users-management',
    name:'users-management',
    component: UsersManagement,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/user-edit',
    name:'user-new',
    component:UserProfile,
    meta: {
      requiresAuth:true
    }
  },
  {
    path:'/user-edit/:user_id',
    name:'user-edit',
    component:UserProfile,
    meta: {
      requiresAuth:true
    }
  },
  {
    path:'/legacy-subscription',
    name:'legacy-subscription',
    component:LegacySubscription,
    meta: {
      requiresAuth:true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    axios .get(`${common.supervisorApi}users/is_user_logged`)
          .then(result => {
            if (result.data)
              next();
            else {
              location.href=`${common.mainSite}/3dvo-utility/detector.php?renew-session=true`
            }
          })
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router
